/**
 * Q8 of the adequacy questionnaire: the client's tolerance to temporary devaluations over one
 * year. One list for the AQ capture screen (AqSection) and the SAA page's "Fit with Q8" table
 * (SaaAnalyticsView), so the two always read the same. Values = the backend's
 * `aq_scoring.Q8_DEVALUATION_LIMIT` keys.
 */
export const Q8_OPTIONS: { value: string; label: string }[] = [
  { value: 'up_to_5', label: 'Up to 5%' },
  { value: 'p5_10', label: 'Between 5% and 10%' },
  { value: 'p10_15', label: 'Between 10% and 15%' },
  { value: 'p15_20', label: 'Between 15% and 20%' },
  { value: 'p20_30', label: 'Between 20% and 30%' },
  { value: 'gt_30', label: 'More than 30%' },
];

export const q8Label = (value: string): string =>
  Q8_OPTIONS.find((o) => o.value === value)?.label ?? value;
